export const openedDrawerWidth  = 285
export const closedDrawerWidth  = 75